import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading, ToastController, Platform } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore, AngularFirestoreDocument } from 'angularfire2/firestore';
import * as firebase from 'firebase/app';
import * as moment from 'moment';
import { DateTimeAdapter } from 'ng-pick-datetime';

interface myInterface2 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  title: string;
  sessionDate: Date;
  tasks: string[];
}

@IonicPage()
@Component({
  selector: 'page-session-update',
  templateUrl: 'session-update.html',
})
export class SessionUpdatePage {

  data: any;
  myForm: FormGroup;
  inputFile: any[] = [""];
  files: any[] = [];
  arrayFiles: any[] = [];
  loading: Loading;

  sessionDoc: AngularFirestoreDocument<myInterface2>;
  session: myInterface2;
  public min = moment().format();
  public min2 = new Date();
  public isMobile: boolean;

  constructor(platform: Platform, dateTimeAdapter: DateTimeAdapter<any>, public asf: AngularFirestore, public navCtrl: NavController, public navParams: NavParams, public formBuilder: FormBuilder, public toastCtrl: ToastController, public loadingCtrl: LoadingController) {


    dateTimeAdapter.setLocale('es-ES'); // change locale to spanish
    this.data = this.navParams.get("item");
    this.myForm = this.formBuilder.group({
      description: [this.data && this.data.description ? this.data.description : '', Validators.required],
      title: [this.data && this.data.title ? this.data.title : '', Validators.required],
      sessionDate: [this.data && this.data.sessionDate ? moment(this.data.sessionDate).toISOString() : '', Validators.required],
    });

    this.sessionDoc = this.asf.doc("Sessions/" + this.data.id);
    this.sessionDoc.snapshotChanges().subscribe(item => {
      const data = item.payload.data() as myInterface2;
      const id = item.payload.id;
      this.session = { id, ...data };
      this.myForm.setValue({
        "description": this.data && this.data.description ? this.data.description : '',
        // "observations": this.data && this.data.observations ? this.data.observations : '',
        "title": this.data && this.data.title ? this.data.title : '',
        "sessionDate": this.data && this.data.sessionDate ? moment(this.data.sessionDate).format('YYYY-MM-DDThh:mm:ss.SSS') : ''
      });
    });
    platform.ready().then(() => {
      if (platform.is('mobile')) {
        this.isMobile = true;
      } else {
        ////console.log('browser');
        this.isMobile = false;
      }
    });
  }

  ionViewDidLoad() { }

  deleteFromArray(index: number) {
    //agregar funcion para eliminar los archivos de estorage
    this.presentLoadingCustom();
    this.session.files.splice(index, 1);
    this.asf.doc('Sessions/' + this.data.id).update({ "files": this.session.files }).then(res => {
      this.loading.dismiss();
      this.presentToast("Archivo agregado correctamente");
    }).catch(error => {
      this.loading.dismiss();
      ////console.log(error);
      this.presentToast(error);
    });
  }

  addFile(event: any) {
    if (event && event.target && event.target.value) {
      this.presentLoadingCustom();
      this.uploadFileSStorage({ "file": event.target.files[0] }).then((data) => {
        this.session.files.push(data);
        this.asf.doc('Sessions/' + this.data.id).update({ "files": this.session.files }).then(res => {
          this.loading.dismiss();
          this.presentToast("Archivo agregado correctamente");
        }).catch(error => {
          this.loading.dismiss();
          ////console.log(error);
          this.presentToast(error);
        });
      }).catch((error) => {
        this.loading.dismiss();
        ////console.log(error);
        this.presentToast(error);
      });
    }
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  async uploadFileSStorage(file: any): Promise<any[]> {
    let filesRet;
    var storageRef = firebase.storage().ref();
    var fileRef = storageRef.child('files/' + new Date().getTime() + file.file.name);
    await fileRef.put(file.file).then((res) => {
      filesRet = { "downloadURL": res.downloadURL, "fullPath": res.metadata.fullPath, "name": file.file.name }
    });
    return filesRet;
  }

  editToDb() {
    this.presentLoadingCustom();
    
    let date;
    if (this.isMobile) {
      let dif = (moment(this.myForm.value.sessionDate).utcOffset() / 60) * -1;
      date = moment(this.myForm.value.sessionDate).add(dif, "hours");
    } else {
      date = this.myForm.value.sessionDate;
    }
    let data = {
      description: this.myForm.value.description,
      title: this.myForm.value.title,
      sessionDate: new Date(date)
    }
    this.asf.doc('Sessions/' + this.data.id).update(data).then(res => {
      this.loading.dismiss();
      this.presentToast("Editado correctamente");
      this.navCtrl.pop();
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast(error);
    });

  }

  cancel() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/session-update/session-update.ts